module.exports = __webpack_public_path__ + "static/media/IMG_0585y.be36eaec.jpg";